export const LOGIN_REQUEST = 'auth/LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGIN_ERROR = 'auth/LOGIN_ERROR';
export const LOGOUT_REQUEST = 'auth/LOGOUT_REQUEST';
export const LOGOUT = 'auth/LOGOUT';
export const LOGOUT_ERROR = 'auth/LOGOUT_ERROR';
export const LOGOUT_COMPLETE = 'auth/LOGOUT_COMPLETE';
export const GOOGLE_SSO_LOGIN_REQUEST = 'auth/GOOGLE_SSO_LOGIN_REQUEST';
